import React, { useEffect, useState, useContext } from "react";
import useCeo from "../../hooks/useCEO";
import { useUnidades } from "../../hooks/test/useUnidades";
import { AuthContext } from "../../context/authContext/authContext";

import MUIDataTable from "mui-datatables";
import { IconButton, Popover, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import TuneIcon from "@mui/icons-material/Tune";
import RemoveIcon from "@mui/icons-material/Remove";

import "moment/locale/es-mx";
import Filtros from "./../../components/Filtros";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faMagnifyingGlass,
  faThumbsDown,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { BitacoraUnidadModal } from "../../components/customComponents/Modals/BitacoraUnidadesModal";
import { EditCreateTripulante } from "../../components/customComponents/Modals/ModalCreateEdit";
import { Spinner } from "../../components/Spinner";

// Toolbar con popup que recibe props
const ToolbarPopup = ({ negocioId, handleChange, setShowModalCrud }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { user } = useContext(AuthContext);

  const handleClick = (event) =>
    setAnchorEl(anchorEl ? null : event.currentTarget);

  const open = Boolean(anchorEl);
  const id = open ? "popup-empty" : undefined;

  return (
    <>
      {[1, 2].includes(parseInt(user.negocio_id)) && (
        <IconButton
          onClick={handleClick}
          title={open ? "Cerrar Filtros Cliente" : "Abrir Filtros Cliente"}
        >
          {open ? <RemoveIcon /> : <TuneIcon />}
        </IconButton>
      )}
      <IconButton
        onClick={() => setShowModalCrud(true)}
        title="Crear Tripulante"
      >
        <AddIcon />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ bgcolor: "white" }} />
        <div style={{ padding: 16, maxWidth: 600 }}>
          <Filtros
            config={["negocio"]}
            valores={{ negocioId: negocioId }}
            onChange={handleChange}
            setShowModalCrud={setShowModalCrud}
          />
        </div>
      </Popover>
    </>
  );
};

const columns = [
  { name: "Nombre Completo", label: "Nombre Completo" },
  { name: "Teléfono", label: "Teléfono" },
  { name: "Tipo", label: "Tipo" },
  { name: "Cedis", label: "Cedis" },
  { name: "Disponibilidad", label: "Disponibilidad" },
  {
    name: "Acción",
    label: "Acción",
    options: {
      download: false, // 👈 visible pero no se exporta
      filter: false,
      sort: false,
    },
  },
];

export const TableroTripulantes = () => {
  useCeo({
    title: "Módulo de Administración de tripulantes",
    description: "Página de tripulantes",
  });
  const [data, setData] = useState([]);
  const { user } = useContext(AuthContext);
  const [negocioId, setNegocioId] = useState(user.negocio_id);
  const [cliente, setCliente] = useState("");
  const [selectedTripulante, setSelectedTripulante] = useState(null);
  const [loading, setLoading] = useState(false);

  // view tripulante
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = (tripulante_id) => {
    setSelectedTripulante(tripulante_id);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTripulante(null);
  };

  // create/edit tripulante
  const [showModalCrud, setShowModalCrud] = useState(false);
  const handleOpenModalCrud = (tripulante_id) => {
    setSelectedTripulante(tripulante_id);
    setShowModalCrud(true);
  };
  const handleCloseModalCrud = () => {
    setShowModalCrud(false);
    setSelectedTripulante(null);
  };

  const { getTripulantesIdNegocio, bajaTipulante, actualizarTripulante } =
    useUnidades();

  const handleChange = (campo, valor) => {
    if (campo === "negocio") setNegocioId(valor); // 👉 solo guarda el id
  };

  useEffect(() => {
    fetchTripulantes();
  }, [negocioId]);

  const fetchTripulantes = async () => {
    if (!negocioId) return;

    setData([]);
    try {
      setLoading(true);
      const resp = await getTripulantesIdNegocio(negocioId);
      setCliente(resp.cliente || "");
      if (resp.ok && Array.isArray(resp.tripulantes)) {
        const array = resp.tripulantes.map((trip) => {
          const {
            tripulante_id,
            nombre_completo,
            telefono,
            tipo_tripulante,
            cedi,
            ocupado,
            disponible,
          } = trip;
          return [
            nombre_completo || "N/A",
            telefono || "N/A",
            tipo_tripulante.descripcion || "N/A",
            cedi ? cedi.nombre_cedis : "N/A",
            ocupado ? "Ocupado" : !disponible ? "Deshabilitado" : "Disponible",
            <>
              {ocupado ? (
                <FontAwesomeIcon
                  onClick={() => {
                    if (ocupado || !disponible) handleOpenModal(tripulante_id);
                  }}
                  icon={faMagnifyingGlass}
                  style={{ cursor: "pointer", color: "blue" }}
                  className="col-3 fa-2x"
                  title="Ver detalle de asignación"
                />
              ) : (
                <FontAwesomeIcon
                  icon={!disponible ? faThumbsUp : faThumbsDown}
                  className={`col-3 fa-2x text-${
                    !disponible ? "success" : "danger"
                  } cursor`}
                  title={
                    !disponible
                      ? "Dar de alta tripulante"
                      : "Dar  de baja tripulante"
                  }
                  onClick={async () => {
                    return Swal.fire({
                      title: `¿Deseas ${
                        !disponible ? "habilitar" : "deshabilitar"
                      }, al tripulante ${nombre_completo}?`,
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "¡Sí!",
                      cancelButtonText: "No",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        return statusTripulante(
                          tripulante_id,
                          !disponible ? true : false
                        );
                      }
                    });
                  }}
                />
              )}
              <FontAwesomeIcon
                icon={faEdit}
                className={`col-3 fa-2x ${
                  !disponible || ocupado ? "text-muted" : "cursor text-ligth"
                }`}
                onClick={() => {
                  if (!ocupado && disponible)
                    handleOpenModalCrud(tripulante_id);
                }}
                title={
                  !disponible || ocupado ? "Accion no disponible" : "Editar"
                }
              />
            </>,
          ];
        });
        setData(array);
      } else {
        setData([]);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error al cargar tripulantes:", error);
    }
  };

  const options = {
    download: data.length > 0,
    selectableRows: "none",
    responsive: "standard", // mejor para tablas anchas
    fixedHeader: true, // mantiene header visible al hacer scroll
    downloadOptions: {
      filename: cliente
        ? `Tripulantes en Bitácora ${cliente}`
        : "Sin información",
      filterOptions: {
        useDisplayedColumnsOnly: false, // 👈 exporta también las ocultas
        useDisplayedRowsOnly: true,
      },
      charset: "utf-8",
    },
    onDownload: (buildHead, buildBody, columns, data) =>
      "\uFEFF" + buildHead(columns) + buildBody(data),
    customToolbar: () =>
      !loading ? ( // solo se muestra cuando ya cargó
        <ToolbarPopup
          negocioId={negocioId}
          handleChange={handleChange}
          setShowModalCrud={setShowModalCrud}
        />
      ) : null,
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro de tabla",
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas de tabla",
      },
      selectedRows: {
        text: "Fila(s) seleccionada(s)",
        delete: "Remover",
        deleteAria: "Fila seleccionada removida",
      },
    },
  };
  // Habilitamos o deshabilitamos
  const statusTripulante = async (id, status) => {
    let resp = [];
    if (status) {
      resp = await actualizarTripulante(id, {
        disponible: 1,
      });
    } else {
      resp = await bajaTipulante(id);
    }

    if (resp) {
      // tripulantes();
      return Swal.fire({
        title: "Operación realizada correctamente",
        text: resp.msg,
        icon: "success",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          fetchTripulantes(); // 🔹 recarga la tabla de tripulantes
        }
      });
    } else {
      return Swal.fire({
        title: "Lo siento, no se pudo realizar la operación",
        text: resp.msg,
        icon: "info",
      });
    }
  };

  return (
    <>
      <div className="p-2">
        {loading && <Spinner />}
        <MUIDataTable
          title={loading ? "Cargando..." : `Tripulantes en Bitácora ${cliente}`}
          data={data}
          columns={columns}
          options={options}
        />
      </div>

      {/* 👇 aquí debe estar tu modal */}
      <BitacoraUnidadModal
        tripulante_id={selectedTripulante}
        show={showModal}
        handleClose={handleCloseModal}
        refreshTripulantes={fetchTripulantes} // <-- nuevo prop
      />
      <EditCreateTripulante
        negocio_id={negocioId}
        tripulante_id={selectedTripulante}
        show={showModalCrud}
        handleClose={handleCloseModalCrud}
        refreshTripulantes={fetchTripulantes} // <-- nuevo prop
      />
    </>
  );
};
